import { render, staticRenderFns } from "./UnitDetailsModal.vue?vue&type=template&id=1c3dd3a0&scoped=true&"
import script from "./UnitDetailsModal.vue?vue&type=script&lang=js&"
export * from "./UnitDetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3dd3a0",
  null
  
)

export default component.exports